<!-- Create Component - usb-modal-type-vehicle-info -->
<div
  *ngIf="product"
  class="d-flex align-items-start"
  style="padding: 20px 15px;"
>
  <div class="d-flex flex-column" style="max-width: 195px; width: 100%; margin-bottom: 10px">
    <p class="usb-modal-text--subtitle semi-bold" style="margin-bottom: 2px">Tipo de Vehículo</p>
    <p class="usb-modal-text--subtitle mb-0">
      {{ product?.vehicle?.name }}
    </p>
  </div>

  <div class="d-flex flex-row align-items-start justify-content-between flex-wrap" style="gap: 1.25em; padding-left: 1em; padding-right: 4.8em; width: 65%;">
    <div class="d-flex flex-column align-items-start" style="gap: 1em">
      <div class="d-flex align-items-center justify-content-end" style="gap: 0.35em; height: 45px;">
        <div class="d-flex align-items-center justify-content-center" style="width: 25px;">
          <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color: black; font-family: 'Poppins' !important; font-size: 20px !important;">{{ product?.vehicle.maxPax }}</p>
        </div>
        <div class="d-flex align-items-center justify-content-center" style="width: 30px; height: 30px;">
          <img src="../../../../../assets/icons/search-result/persona.svg" width="30px" height="30px" alt="" />
        </div>
        <div class="d-flex flex-column" style="border-left: 1px solid #b9b9b9;">
          <p class="usb-modal-text--body mb-0" style="padding-left: 0.6em">
            Personas
          </p>
          <p class="usb-modal-text--body mb-0" style="padding-left: 0.6em">
            por vehículo
          </p>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-end" style="gap: 0.35em; height: 45px;">
        <div class="d-flex align-items-center justify-content-center" style="width: 25px;">
          <p *ngIf="product?.vehicle?.number_of_doors && product?.vehicle?.number_of_doors !== ''; else elseDoors" class="rubik-regular-13pt mb-0" style="font-weight: 500; color: black; font-family: 'Poppins' !important; font-size: 20px !important;">{{ product?.vehicle?.number_of_doors }}</p>
          <ng-template #elseDoors>
            <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color: black; font-family: 'Poppins' !important; font-size: 20px !important;">0</p>
          </ng-template>
        </div>
        <div class="d-flex align-items-center justify-content-center" style="width: 30px; height: 30px;">
          <img src="../../../../../assets/icons/search-result/puerta de auto.svg" width="25px" height="25px" alt="" />
        </div>
        <div class="d-flex flex-column justify-content-center" style="border-left: 1px solid #b9b9b9; min-height: 32px;">
          <p class="usb-modal-text--body mb-0" style="padding-left: 0.6em;">
            Puertas
          </p>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-end" style="gap: 0.35em; height: 45px;">
        <div class="d-flex align-items-center justify-content-center" style="width: 25px;">
          <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color: black; font-family: 'Poppins' !important; font-size: 20px !important;">{{ product?.vehicle?.bag?.maxBag }}</p>
        </div>
        <div class="d-flex align-items-center justify-content-center" style="width: 30px; height: 30px;">
          <img src="../../../../../assets/icons/search-result/maleta.svg" width="30px" height="30px" alt="" />
        </div>
        <div class="d-flex flex-column" style="border-left: 1px solid #b9b9b9;">
          <p class="usb-modal-text--body mb-0" style="padding-left: 0.6em;">
            Maletas Grandes
          </p>
          <p class="usb-modal-text--body mb-0" style="padding-left: 0.6em;">
            por vehículo
          </p>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column" style="gap: 1em; margin-left: 10px">
      <div
        class="d-flex align-items-center"
        style="gap: 0.25em; background-color: #f0f0f0; border-radius: 5px; margin-left: 20px; padding: 5px 9px; border: 0.5px solid #dadada; width: 125px; height: 45px;"
      >
        <div class="d-flex align-items-center justify-content-center" style="width: 30px; height: 30px;">
          <img src="../../../../../assets/icons/search-result/tiempo.svg" width="30px" height="30px" alt="" />
        </div>
        <div class="d-flex flex-column" style="border-left: 1px solid #b9b9b9;">
          <p class="usb-modal-text--body mb-0" style="padding-left: 0.6em;">
            {{ roundTripTime }}
          </p>
          <p class="usb-modal-text--body mb-0" style="padding-left: 0.6em;">Minutos</p>
        </div>
      </div>

      <div class="d-flex align-items-center" style="gap: 0.25em; height: 45px;">
        <!-- result['vehicles'].length -->
        <div class="d-flex align-items-center justify-content-center" style="width: 25px;">
          <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color: black; font-family: 'Poppins' !important; font-size: 20px !important;">
            1
          </p>
        </div>
        <div class="d-flex align-items-center justify-content-center" style="width: 30px; height: 30px;">
          <img src="../../../../../assets/icons/search-result/RENT_A_CAR-01-01.svg" width="28px" height="28px" alt="" />
        </div>
        <div *ngIf="product?.vehicle?.year && product?.vehicle?.year !== ''; else elseVehicleYear" class="d-flex flex-column" style="border-left: 1px solid #b9b9b9;">
          <p class="usb-modal-text--body mb-0" style="padding-left: 0.6em;">
            Modelo
          </p>
          <p class="usb-modal-text--body mb-0" style="padding-left: 0.6em;">{{ product?.vehicle?.year }}</p>
        </div>
        <ng-template #elseVehicleYear >
          <div class="d-flex flex-column" style="border-left: 1px solid #b9b9b9;">
            <p class="usb-modal-text--body mb-0" style="padding-left: 0.6em;">
              Modelo
            </p>
            <p class="usb-modal-text--body mb-0" style="padding-left: 0.6em;">
              N/A
            </p>
          </div>
        </ng-template>
      </div>

      <div class="d-flex align-items-center" style="gap: 0.25em; height: 45px;">
        <!-- result['vehicles'].length -->
        <div class="d-flex align-items-center justify-content-center" style="width: 25px;">
          <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color: black; font-family: 'Poppins' !important; font-size: 20px !important;">
            {{ product?.vehicle?.bag.numberHandbags ? product?.vehicle.bag.numberHandbags : 0 }}
          </p>
        </div>
        <div class="d-flex align-items-center justify-content-center" style="width: 30px; height: 30px;">
          <img src="../../../../../assets/icons/search-result/carry.svg" width="30px" height="30px" alt="" />
        </div>
        <div class="d-flex flex-column" style="border-left: 1px solid #b9b9b9;">
          <p class="usb-modal-text--body mb-0" style="padding-left: 0.6em;">
            Maletas Medianas
          </p>
          <p class="usb-modal-text--body mb-0" style="padding-left: 0.6em;">por vehiculo</p>
        </div>
      </div>
    </div>

    <div
      class="d-flex flex-column"
      style="gap: 0.5em; border: 1.5px solid #bfbfbf; border-radius: 10px; padding: 10px 15px; min-width: 135px;"
    >
      <div class="d-flex align-items-center" style="gap: 0.5em">
        <img src="../../../../../assets/icons/search-result/caja automática 01.svg" width="22px" height="22px" alt="" />
        <p class="usb-modal-text--body mb-0">
          {{ product?.vehicle?.transmision === "Automático" ? "Automática" : "Manual" }}
        </p>
      </div>
      <div class="d-flex align-items-center" style="gap: 0.5em">
        <img src="../../../../../assets/icons/search-result/aire acondicionado 02.svg" width="22px" height="22px" alt="" />
        <p class="usb-modal-text--body mb-0">
          {{ product?.vehicle?.transmision === "Con Aire Acondicionado" ? "Aire" : "Sin aire" }}
        </p>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center">
    <img src="{{ product.images[0]?.thumbnail }}" width="auto" height="auto" alt="" style="background-size: cover; width: 220px; height: 110px; object-fit: cover;" />
  </div>
</div>

<div class="d-flex mb-2 mt-3" style="border: 1px solid #ccc; border-radius: 6px; margin-left: 0.75em; margin-right: 0.75em">
  <div class="d-flex align-items-center" style="width: 47.5%; gap: 0.5em; padding-top: 12px; padding-bottom: 12px">
    <img class="ml-3" src="../../../../../../assets/icons/search-result/tour/gps.svg" width="22px" height="22px" alt="" />
    <p class="mb-0 usb-modal-text--body pr-3">
      {{ extractNameTransport(infoTransfer.firstOrigin, "origin") }} >
      {{ extractNameTransport(infoTransfer.firstDestination, "destination") }}
    </p>
  </div>
  <div
    class="d-flex align-items-center"
    style="
      width: 23.5%;
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;
      gap: 0.5em;
      padding-top: 12px;
      padding-bottom: 12px;
      padding-left: 1.2em;
    "
  >
    <img src="../../../../../../assets/icons/itinerary/calendar_13937514.svg" width="30px" height="30px" alt="" />
    <p class="mb-0 usb-modal-text--body">
      {{ resolvedFirstArrivalDate | date: "EEEE dd MMMM" : undefined : "es" }}
    </p>
  </div>
  <div class="d-flex align-items-center" style="width: 23.5%; gap: 0.5em; padding-top: 12px; padding-bottom: 12px; padding-left: 2em">
    <img src="../../../../../../assets/icons/itinerary/persona.svg" width="22px" height="22px" alt="" />
    <p class="mb-0 usb-modal-text--body">
      {{ infoTransfer.firstqtyAdults }} {{ infoTransfer.firstqtyAdults === 1 ? "adulto" : "adultos" }} - {{ infoTransfer.firstqtyChilds }}
      {{ infoTransfer.firstqtyChilds > 1 ? "niños" : "niño" }}
    </p>
  </div>
</div>

<div
  class="d-flex flex-column"
  style="
    background-color: #f9f9f9;
    margin-left: 0.75em;
    margin-right: 0.75em;
    margin-top: 25px;
    margin-bottom: 25px;
    padding-top: 2.2em;
    padding-bottom: 2.2em;
  "
>
  <div class="d-flex mx-auto" style="width: 97%">
    <div class="d-flex flex-column" style="width: 25%">
      <div class="d-flex flex-column" style="margin-bottom: 30px; margin-left: 17px">
        <p class="usb-modal-text--body-strong poppins" style="margin-bottom: 4px">
          Transfer in:
        </p>
        <p class="usb-modal-text--body-strong poppins" style="margin-bottom: 3px">
          {{ resolvedFirstArrivalDate | date: "dd MMM yyyy" }}
        </p>
        <p class="usb-modal-text--body mb-0">
          {{ infoTransfer.firstTime }} hs.
        </p>
      </div>
      <div class="d-flex flex-column" style="margin-left: 17px">
        <p class="usb-modal-text--body-strong poppins" style="margin-bottom: 4px">Transfer out:</p>
        <p class="usb-modal-text--body-strong poppins" style="margin-bottom: 3px">
          {{ (resolvedSecondArrivalDate ? resolvedSecondArrivalDate : resolvedFirstArrivalDate) | date: "dd MMM yyyy" }}
        </p>
        <p class="usb-modal-text--body mb-0">
          {{ getTimeDropoff() || 'horario a confirmar' }} hs.
        </p>
      </div>
    </div>
    <div class="d-flex flex-column" style="width: 25%">
      <div *ngIf="quote" class="d-flex flex-column ml-1" style="margin-bottom: 30px">
        <p class="usb-modal-text--body-strong poppins" style="margin-bottom: 4px">
          Precio viaje
        </p>
        <div class="d-flex" style="margin-bottom: 3px">
          <p class="usb-modal-text--body-strong poppins mb-0">
            {{ currencyAgency?.code }}
            {{
              product?.totalPriceProf
                | currencyConverterPure: product?.pricing?.currency : currencyAgency.code : currencies
                | number: "1.2-2"
            }}
          </p>
          <usb-tooltip-convert-amount
            [clientsSettingAppBooking]="clientSetting"
            [currencyProduct]="product.pricing?.currency"
            [valueProduct]="product.totalPriceProf"
          ></usb-tooltip-convert-amount>
        </div>

        <p class="usb-modal-text--body mb-0">
          imp. incluidos
        </p>
      </div>
      <div *ngIf="quote" class="d-flex flex-column ml-1">
        <p class="usb-modal-text--body-strong poppins" style="margin-bottom: 4px">
          Adicionales
        </p>
        <div class="d-flex" style="margin-bottom: 3px">
          <p class="usb-modal-text--body-strong poppins mb-0">
            {{ currencyAgency?.code }}
            {{
              (product.amenitiesIncluded?.length > 0 ? product?.netPriceBookingWithIncluded - product?.totalPriceProf : 0)
                | currencyConverterPure: product?.pricing?.currency : currencyAgency.code : currencies
                | number: "1.2-2"
            }}
          </p>
          <usb-tooltip-convert-amount
            [clientsSettingAppBooking]="clientSetting"
            [currencyProduct]="product.pricing?.currency"
            [valueProduct]="product?.netPriceBookingWithIncluded - product?.totalPriceProf"
          ></usb-tooltip-convert-amount>
        </div>

        <p class="usb-modal-text--body mb-0">imp. incluidos</p>
      </div>
    </div>
    <div class="d-flex flex-column" style="gap: 1em; width: 25%">
      <div class="d-flex" style="gap: 10px; margin-bottom: 30px">
        <img src="../../../../../assets/icons/search-result/duración.svg" width="35px" height="35px" alt="" />

        <div class="d-flex flex-column">
          <p class="usb-modal-text--body-strong" style="margin-bottom: 4px">
            Duración:
          </p>
          <p class="usb-modal-text--body" style="margin-bottom: 3px">
            {{ product?.timing?.entry?.entryTravelTime }} minutos
          </p>
        </div>
      </div>
      <div class="d-flex flex-column">
        <div>
          <p class="usb-modal-text--body-strong" style="margin-bottom: 3px">
            Condiciones
          </p>
        </div>
        <div class="d-flex flex-column">
          <div class="d-flex flex-column">
            <span *ngIf="product?.pricing?.rateClass === 'R'">
              <div class="d-flex align-items-center">
                <i class="bi bi-check-lg" style="font-size: 18px; line-height: 1"></i>
                <p
                  class="usb-modal-text--body-strong light"
                  style="
                    margin-bottom: 2px;
                    color: #69d299;
                  "
                >
                  REEMBOLSABLE
                </p>
              </div>
              <p
                class="usb-modal-text--body mb-0"
                (click)="openPolitics()"
                style="
                  cursor: pointer;
                  color: #69d299;
                "
              >
                hasta: 04/07/2023
              </p>
            </span>
            <span *ngIf="product?.pricing?.rateClass === 'NR'">
              <div class="d-flex">
                <p
                  class="usb-modal-text--body-strong light"
                  style="
                    margin-bottom: 2px;
                    color: #b70d35;
                  "
                >
                  No Reembolsable
                </p>
              </div>
              <p
                class="usb-modal-text--body mb-0"
                style="color: #b70d35"
              >
                100% Tarifa
              </p>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column align-items-start" style="width: 22%">
      <div style="margin-bottom: 44px">
        <p class="usb-modal-text--body-strong light" style="margin-bottom: 4px">
          Tipo de traslado
        </p>
        <p class="usb-modal-text--body-strong" style="margin-bottom: 4px">
          {{ product?.transferType }}
        </p>
      </div>

      <div style="padding: 0px; border-radius: 10px; max-width: 120px;">
        <img src="{{ product?.logo }}" style="height: 55px; width: 100%; object-fit: contain" alt="" />
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="amenitiesVisible()"
  class="d-flex mb-2 mt-2 pt-4 pb-4"
  style="border: 1px solid #ccc; border-radius: 6px; margin-left: 0.75em; margin-right: 0.75em"
>
  <div class="d-flex flex-column w-100 ml-4">
    <p class="mb-2 usb-modal-text--body-strong">Incluido</p>
    <div class="d-flex flex-column">
      <ng-container *ngIf="hasIncludedAmenities(); else noIncluded">
        <ng-container *ngFor="let includes of product.amenities">
          <ng-container *ngIf="includes?.included">
            <div class="d-flex align-items-center" style="gap: 3px;">
              <i class="bi bi-check" style="line-height: 1; color: #00d096; font-size: 1.5em"></i>
              <p class="mb-0 usb-modal-text--body">
                {{ includes.name }}
              </p>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-template #noIncluded>
        <p class="mb-0 usb-modal-text--body">N/A</p>
      </ng-template>
    </div>
  </div>
  <div class="d-flex flex-column w-100">
    <p class="mb-2 usb-modal-text--body-strong">Adicionales</p>
    <div class="d-flex flex-column">
      <ng-container *ngIf="product.amenitiesIncluded && product.amenitiesIncluded.length > 0">
        <ng-container *ngFor="let includes of product.amenitiesIncluded">
          <div class="d-flex">
            <p class="mb-0 usb-modal-text--body">
              {{ includes.name }}
              <span style="font-weight: 600">
                <!-- ({{currencySelected}} {{includes.price | number: '1.2-2'}}) -->
                ({{ currencyAgency?.code }}
                {{ includes.price | currencyConverterPure: currencySelected : currencyAgency.code : currencies | number: "1.2-2" }})
              </span>
            </p>
            <usb-tooltip-convert-amount
              [clientsSettingAppBooking]="clientSetting"
              [currencyProduct]="includes.currency"
              [valueProduct]="includes.totalPriceProf"
            >
            </usb-tooltip-convert-amount>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="product.amenitiesIncluded && product.amenitiesIncluded.length === 0">
        <p class="mb-0 usb-modal-text--body">N/A</p>
      </ng-container>
    </div>
  </div>
</div>

<!-- Traslado de Llegada (solo si destino es aeropuerto) -->
<div
  *ngIf="getArrivalFlight() as flight"
  class="d-flex mb-2 mt-2 pt-4 pb-5"
  style="border: 1px solid #ccc; border-radius: 6px; margin-right: 0.75em; margin-left: 0.75em"
>
  <div class="d-flex flex-column w-100 mx-4">
    <div class="mb-4">
      <p class="mb-0 usb-modal-text--body-strong light">
        Traslado:
        <span style="font-weight: 600">
          {{ extractNameTransport(infoTransfer.firstOrigin, "origin") }},
          {{ extractNameTransport(infoTransfer.firstDestination, "destination") }}
        </span>
      </p>
    </div>

    <div class="row m-0">
      <div class="col-6 pl-0">
        <label class="d-flex flex-column" style="gap: 10px;">
          <span class="usb-modal-text--body-strong" style="padding-left: 25px;">Código de vuelo</span>
          <div class="w-100 position-relative">
            <select
              name="code"
              style="appearance: none; border-radius: 8px; height: 50px !important; padding: 0px 25px;"
              class="form-control input-search-box select-style"
            >
              <option value="{{flight?.airportIataCodeIn}}">{{flight?.airportIataCodeIn}}{{flight?.flyNumberIn}}</option>
            </select>
            <img
              width="12"
              height="12"
              style="position: absolute; right: 1.5em; top: 40%"
              src="../../../../../../assets/img/app/little-icons/arrow-down-black.svg"
            />
          </div>
        </label>
      </div>

      <div class="col-6 pr-0">
        <label class="d-flex flex-column" style="gap: 10px;">
          <span class="usb-modal-text--body-strong" style="padding-left: 25px;">Hora de llegada de vuelo</span>
          <div class="w-100 position-relative">
            <select
              name="code"
              style="appearance: none; border-radius: 8px; height: 50px !important; padding: 0px 25px;"
              class="form-control input-search-box select-style"
            >
              <option value="{{_extractHourMinute(flight?.arrivalIn)}}">{{_extractHourMinute(flight?.arrivalIn)}}</option>
            </select>
            <img
              width="12"
              height="12"
              style="position: absolute; right: 1.5em; top: 40%"
              src="../../../../../../assets/img/app/little-icons/arrow-down-black.svg"
            />
          </div>
        </label>
      </div>
    </div>

    <!-- Fila 1: Aerolínea y Nro. Vuelo -->
    <!-- <div class="d-flex mt-4" style="gap: 1em"> -->
    <!--   <div class="d-flex flex-column" style="flex: 2"> -->
    <!--     <label class="ml-3 usb-modal-text--body-strong">Aerolínea</label> -->
    <!--     <input -->
    <!--       type="text" -->
    <!--       class="py-2 pl-3 usb-modal-text--body" -->
    <!--       style="border: 1px solid #ccc; border-radius: 6px" -->
    <!--       [value]="flight.airlineIn || 'No especificada'" -->
    <!--       readonly -->
    <!--     /> -->
    <!--   </div> -->
    <!--   <div class="d-flex flex-column" style="flex: 1"> -->
    <!--     <label class="ml-3 usb-modal-text--body-strong">Nro. Vuelo</label> -->
    <!--     <input -->
    <!--       type="text" -->
    <!--       class="py-2 pl-3 usb-modal-text--body" -->
    <!--       style="border: 1px solid #ccc; border-radius: 6px" -->
    <!--       [value]="flight.flyNumberIn" -->
    <!--       readonly -->
    <!--     /> -->
    <!--   </div> -->
    <!-- </div> -->
    <!--
    <!-- <!-- Fila 2: Aeropuerto de Llegada y Hora -->
    <!-- <div class="d-flex mt-3" style="gap: 1em"> -->
    <!--   <div class="d-flex flex-column" style="flex: 2"> -->
    <!--     <label class="ml-3 usb-modal-text--body-strong">Aeropuerto de Llegada</label> -->
    <!--     <input -->
    <!--       type="text" -->
    <!--       class="py-2 pl-3 usb-modal-text--body" -->
    <!--       style="border: 1px solid #ccc; border-radius: 6px" -->
    <!--       [value]="flight.airportIn || extractNameTransport(infoTransfer.firstDestination, 'destination')" -->
    <!--       readonly -->
    <!--     /> -->
    <!--   </div> -->
    <!--   <div class="d-flex flex-column" style="flex: 1"> -->
    <!--     <label class="ml-3 usb-modal-text--body-strong">Hora de Llegada</label> -->
    <!--     <input -->
    <!--       type="text" -->
    <!--       class="py-2 pl-3 usb-modal-text--body" -->
    <!--       style="border: 1px solid #ccc; border-radius: 6px" -->
    <!--       [value]="_extractHourMinute(flight.arrivalIn)" -->
    <!--       readonly -->
    <!--     /> -->
    <!--   </div> -->
    <!-- </div> -->
  </div>
</div>

<div
  *ngIf="getDepartureFlight() as flight"
  class="d-flex mb-2 mt-2 pt-3 pb-5"
  style="border: 1px solid #ccc; border-radius: 6px; margin-right: 0.75em; margin-left: 0.75em"
>
  <div class="d-flex flex-column w-100 mx-4">
    <div>
      <p class="mb-0 usb-modal-text--body">
        Traslado de Salida:
        <span style="font-weight: 600">
          {{ extractNameTransport(infoTransfer.firstOrigin, "origin") }} →
          {{ extractNameTransport(infoTransfer.firstDestination, "destination") }}
        </span>
      </p>
    </div>

    <!-- Fila 1: Aerolínea y Nro. Vuelo -->
    <div class="d-flex mt-4" style="gap: 1em">
      <div class="d-flex flex-column" style="flex: 2">
        <label class="ml-3" style="font-family: &quot;Rubik&quot;, serif; font-size: 13px; font-weight: 600">Aerolínea</label>
        <input
          type="text"
          class="py-2 pl-3"
          style="font-family: &quot;Rubik&quot;, serif; font-size: 13px; border: 1px solid #ccc; border-radius: 6px"
          [value]="flight.airlineOut || 'No especificada'"
          readonly
        />
      </div>
      <div class="d-flex flex-column" style="flex: 1">
        <label class="ml-3" style="font-family: &quot;Rubik&quot;, serif; font-size: 13px; font-weight: 600">Nro. Vuelo</label>
        <input
          type="text"
          class="py-2 pl-3"
          style="font-family: &quot;Rubik&quot;, serif; font-size: 13px; border: 1px solid #ccc; border-radius: 6px"
          [value]="flight.flyNumberOut"
          readonly
        />
      </div>
    </div>

    <!-- Fila 2: Aeropuerto de Salida y Hora -->
    <div class="d-flex mt-3" style="gap: 1em">
      <div class="d-flex flex-column" style="flex: 2">
        <label class="ml-3" style="font-family: &quot;Rubik&quot;, serif; font-size: 13px; font-weight: 600">Aeropuerto de Salida</label>
        <input
          type="text"
          class="py-2 pl-3"
          style="font-family: &quot;Rubik&quot;, serif; font-size: 13px; border: 1px solid #ccc; border-radius: 6px"
          [value]="flight.airportOut || extractNameTransport(infoTransfer.firstOrigin, 'origin')"
          readonly
        />
      </div>
      <div class="d-flex flex-column" style="flex: 1">
        <label class="ml-3" style="font-family: &quot;Rubik&quot;, serif; font-size: 13px; font-weight: 600">Hora de Salida</label>
        <input
          type="text"
          class="py-2 pl-3"
          style="font-family: &quot;Rubik&quot;, serif; font-size: 13px; border: 1px solid #ccc; border-radius: 6px"
          [value]="_extractHourMinute(flight.departureOut)"
          readonly
        />
      </div>
    </div>
  </div>
</div>

<usb-accordion-info-product
  #accordionComponent
  [items]="accordionItemsData"
  [config]="accordionConfigData"
  [categoryId]="8"
  (itemToggle)="onAccordionToggle($event)"
  style="margin-right: 0.75em; margin-left: 0.75em"
>
  <ng-template #accordionContent let-item let-index="index">
    <ng-container [ngSwitch]="item.id">
      <!-- Descripción -->
      <div *ngSwitchCase="'description'">
        <p class="mb-0 usb-modal-text--body"
        [innerHTML]="descriptionData"
        *ngIf="item.data.description; else noDesc"></p>
        <ng-template #noDesc>
          <p class="text-muted">No hay información disponible</p>
        </ng-template>
      </div>

      <!-- Políticas de Cancelación -->
      <div *ngSwitchCase="'policies'">
        <usb-cancellation-policies
          class="accordion-item-policies"
          #politicsSection
          [cancellationPolicies]="cancellationData"
          [currencies]="currencies"
          [currencyAgency]="currencyAgency"
          [categoryId]="8"
        >
        </usb-cancellation-policies>
      </div>
    </ng-container>
  </ng-template>
</usb-accordion-info-product>
